import { api } from '@/global/api'
import { GetFilterResponse } from '@/modules/accredited-establishments/api/types'

export const getSubSpecialtiesFilterOptions = async (
  specialtyId: string
): Promise<GetFilterResponse> => {
  const { data } = await api.get<GetFilterResponse>(
    `/site_accredited_network/v2/filters/sub_specialties`,
    { params: { specialtyId } }
  )
  return data
}
